import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class CodeScac extends TrackableEntity {
    carrierName: string = '';
    code: string = '';
    senderId: string = '';
    receiverId: string = '';
    customerCode: string = '';
    companyId: number = 0;
    companyName: string = '';
    oiAcctCom: number = 0;
    oiAcctComName: string = '';
    ooAcctCom: number = 0;
    ooAcctComName: string = '';
    id: number = 0;


    // for cloud
    indicator?: number = 0;
    // Current operation
    edit: boolean = false;
    view: boolean= false;
    editIndex?: number = 0;

    constructor(init?:Partial<CodeScac>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return CodeScac.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'carrierName': new DBMappingInfo({ field: 'F_CARRIERNAME', table: 'T_CODESCAC' }),
        'code': new DBMappingInfo({ field: 'F_CODE', table: 'T_CODESCAC' }),
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_CODESCAC' }),
        'companyId': new DBMappingInfo({ field: 'F_COMPANYID', table: 'T_CODESCAC' }),
        'senderId': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_CODESCAC', tbId: '@ScacId', type: 0 }),
        'receiverId': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_CODESCAC', tbId: '@ScacId', type: 0 }),
        'customerCode': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_CODESCAC', tbId: '@ScacId', type: 0 }),
        'oiAcctCom': new DBMappingInfo({ field: 'F_N1', table: 'T_AOTHERINFO', tbName: 'T_CODESCAC', tbId: '@ScacId', type: 0 }),
        'ooAcctCom': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO', tbName: 'T_CODESCAC', tbId: '@ScacId', type: 0 }),

    };
}
